<template>
  <div class="container" :style="{ opacity: screensaverOpacity }">
    <article class="calendar-wrapper" :class="{ visible: screensaverOpacity }">
      <header>
        <h1>
          {{ $t(`monthNames[${eventDates[0].getMonth()}]`) }}
          {{ eventDates[0].getFullYear() }}
        </h1>
      </header>
      <main class="calendar">
        <div class="header" v-for="day in 7" :key="day">
          {{ $t(`weekdaysShort[${day - 1}]`) }}
        </div>
        <template v-for="week in 6">
          <div
            class="day"
            v-for="day in 7"
            :key="`${week}-${day}`"
            :class="[
              {
                inMonth: dayInMonth(0, week, day),
              },
              ...dayClasses(week, day),
            ]"
            :style="{
              'animation-delay': `${(day + week * 7) * 1}s`,
            }"
          >
            <div>
              {{ displayDay(0, week, day) }}
            </div>
            <div
              style="font-weight: bold"
              v-for="(eventDate, index) in eventDates"
              v-if="displayDay(index, week, day) === eventDate.getDate()"
            >
              {{ $t(`party_dates[${index}]`) }}
            </div>
          </div>
        </template>
      </main>
    </article>
    <article
      class="save-the-date newsletter accent-didi"
      :class="{ visible: screensaverOpacity }"
    >
      <header>
        <h1>Save the Date</h1>
      </header>
      <main>
        <p>
          Die nächste Frechdax ABDL Party steigt am<br />
          <span class="en"> Our next Frechdax ABDL Party takes place on </span>
        </p>
        <p style="font-size: 1.25em">
          <strong>
            {{ $i18n.messages.de.weekdaysLong[nextPartyDate.weekday] }},
            {{ nextPartyDate.day }}.
            {{ $i18n.messages.de.monthNames[nextPartyDate.month - 1] }}
            {{ nextPartyDate.year }}<br />
            <span class="en">
              {{ $i18n.messages.en.weekdaysLong[nextPartyDate.weekday] }},
              {{ $i18n.messages.en.monthNames[nextPartyDate.month - 1] }}
              {{ nextPartyDate.day }}, {{ nextPartyDate.year }}
            </span>
          </strong>
        </p>
        <!-- <p>
                  Ticketverkauf ab {{ ticketSaleStart.day }}. {{ $i18n.messages.de.monthNames[ticketSaleStart.month - 1] }} {{ ticketSaleStart.year }}, {{ ticketSaleStart.hour }}:00 Uhr.<br/>
                  <span class="en">
                    Ticket sale begins on {{ $i18n.messages.en.monthNames[ticketSaleStart.month - 1] }} {{ ticketSaleStart.day }}, {{ ticketSaleStart.year }}, {{ ticketSaleStart.hour }}.00.
                  </span>
                </p> -->
      </main>
    </article>
  </div>
</template>
<script>
export default {
  props: ["screensaverOpacity"],
  computed: {
    firstOfMonth() {
      return this.eventDates.map((eventDate) => {
        let newDate = new Date(eventDate.getTime());
        newDate.setDate(1);
        return newDate;
      });
    },
    lastOfMonth() {
      return this.firstOfMonth.map((date) => {
        let newDate = new Date(date.getTime());
        newDate.setMonth(newDate.getMonth() + 1);
        newDate.setDate(0);
        return newDate;
      });
    },
  },
  methods: {
    dayHasEvent(week, day) {
      return this.eventDates.some((date, idx) => {
        return this.displayDay(idx, week, day) === date.getDate();
      });
    },
    dayClasses(week, day) {
      return this.eventDates.map((date, idx) => {
        if (this.displayDay(idx, week, day) === date.getDate()) {
          return ["party", this.eventClasses[idx]];
        }
      });
    },
    dayInMonth(idx, week, day) {
      return (
        this.firstOfMonth[idx].getDate() <= this.displayDay(idx, week, day) &&
        this.lastOfMonth[idx].getDate() >= this.displayDay(idx, week, day)
      );
    },
    displayDay(idx, week, day) {
      if (week === 1 && day < this.firstOfMonth[idx].getDay()) {
        return null;
      }

      let dayOffset =
        (week - 1) * 7 + day - this.firstOfMonth[idx].getDay() + 1;
      if (dayOffset > this.lastOfMonth[idx].getDate()) {
        return null;
      }

      return dayOffset;
    },
    weekDayLocalized(day) {
      return ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"][day - 1];
    },
  },
  data() {
    return {
      nextPartyDate: JSON.parse(process.env.VUE_APP_NEXT_PARTY_DATE),
      ticketSaleStart: JSON.parse(process.env.VUE_APP_TICKET_SALE_START),
      ticketSaleStartAvailable:
        process.env.VUE_APP_NEXT_PARTY_DATE !=
        process.env.VUE_APP_TICKET_SALE_START,
      eventDates: [
        new Date(2025, 4 - 1, 4),
        new Date(2025, 4 - 1, 5),
        new Date(2025, 4 - 1, 6),
      ],
      eventClasses: [
        "accent-panda accent-didi",
        "accent-volth",
        "accent-patricia",
      ],
    };
  },
};
</script>
<style scoped lang="scss">
$colorMain: #1976d2;
$colorAccent: #fdd835;
$colorPatricia: #f06292;
$accentColors: (
  "didi": $colorMain,
  "patricia": $colorPatricia,
  "volth": $colorAccent,
  "panda": #00963d,
);

div.container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1s linear;
  // font-size: 20px;
}

article.calendar-wrapper {
  position: relative;
  margin-left: 400px;
  width: 1000px;
  min-width: 1000px;
  transition: margin-left 1200ms ease-in-out;

  &.visible {
    margin-left: 300px;
  }

  @media screen and (max-width: 1000px) {
    display: none;
  }

  > header {
    text-align: center;
  }

  > main {
    padding: 8px;
  }

  > main.calendar {
    // background: white;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-gap: 12px;

    .day {
      aspect-ratio: 6/4;
      padding: 6px;
      background-color: rgba(white, 0.5);
      border-radius: 6px;
      opacity: 0.3;
      color: black;
      flex-shrink: 0;
      overflow: hidden;
      font-size: 80%;

      &.inMonth {
        opacity: 1;
      }

      @each $name, $color in $accentColors {
        &.accent-#{$name} {
          background: $color;
          color: contrast-color($color);
        }

        @each $name2, $color2 in $accentColors {
          @if $name != $name2 {
            &.accent-#{$name}.accent-#{$name2} {
              background: linear-gradient(-30deg, $color2 20%, $color 80%);
            }
          }
        }
      }
    }

    .party {
      position: relative;
      background: white;
      box-shadow: 0 2px 12px rgba(black, 0.4);

      > * {
        position: relative;
        z-index: 2;
        color: black;
      }

      // &:before {
      //   $scale: 20%;
      //   content: '';
      //   position: absolute;
      //   top: -$scale;
      //   left: -$scale;
      //   right: -$scale;
      //   bottom: -$scale;
      //   background: rgba(white, 0.6);
      //   border-radius: 100%;
      //   transform: rotate(-10deg);
      //   z-index: 1;
      // }
    }

    .header {
      background-color: transparent;
      margin-left: 8px;
      font-weight: bold;
    }

    @media screen and (max-width: 720px) {
      display: none;
    }
  }
}

div.didi > main .content article.save-the-date {
  text-align: center;
  display: inline-block;
  position: absolute;
  left: 50%;
  margin-left: -800px;
  margin-top: 100px;
  transition: margin-left 1200ms ease-in-out;
  z-index: 0;

  &:before {
    z-index: 0;
  }

  &.visible {
    margin-left: -600px;
  }

  main {
    padding: 2em 4em;
    background: black;
  }
}

span.en {
  color: #1976d2;
}
</style>

<i18n>
  {
    "de": {
      "party_dates": [
        "Meet&Greet",
        "PamperPlay",
        "BabyBrunch"
      ]
    }
  }
  </i18n>
<i18n src="@/locales/global.json" />
